module.exports = __webpack_public_path__ + "img/before6.ebc17642.jpg";